/**
 * AURA Toolbar Component
 * Compact row of action buttons: Reset Settings, Statement, Hide Interface
 */

import { stateManager } from '../core/state';
import { t } from '../core/i18n';

export const TOOLBAR_STYLES = `
  .aura-toolbar {
    display: flex;
    gap: 6px;
    padding: 6px var(--aura-spacing-lg);
    background: var(--aura-bg-secondary);
    border-bottom: 1px solid var(--aura-border);
  }

  .aura-toolbar__btn {
    padding: 4px 12px;
    border-radius: var(--aura-radius-full);
    font-size: 11px;
    font-weight: 500;
    color: var(--aura-text);
    background: var(--aura-bg);
    border: 1px solid var(--aura-border);
    cursor: pointer;
    transition: all var(--aura-transition-fast);
    white-space: nowrap;
  }

  .aura-toolbar__btn:hover {
    background: var(--aura-bg-hover);
    border-color: var(--aura-text-muted);
  }

  .aura-toolbar__btn:focus-visible {
    outline: 2px solid var(--aura-border-focus);
    outline-offset: 2px;
  }
`;

export interface ToolbarCallbacks {
  onStatement: () => void;
  onHideInterface: () => void;
}

export function createToolbar(callbacks: ToolbarCallbacks): HTMLElement {
  const toolbar = document.createElement('div');
  toolbar.className = 'aura-toolbar';
  toolbar.setAttribute('role', 'toolbar');
  toolbar.setAttribute('aria-label', 'Accessibility actions');

  const resetBtn = createButton(() => t('resetSettings'), () => stateManager.reset());
  const statementBtn = createButton(() => t('statement'), callbacks.onStatement);
  const hideBtn = createButton(() => t('hideInterface'), callbacks.onHideInterface);

  toolbar.appendChild(resetBtn);
  toolbar.appendChild(statementBtn);
  toolbar.appendChild(hideBtn);

  return toolbar;
}

function createButton(labelFn: () => string, onClick: () => void): HTMLButtonElement {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'aura-toolbar__btn';
  btn.textContent = labelFn();
  btn.addEventListener('click', onClick);
  return btn;
}
